import { useEffect } from "react";
import { useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import Select from "react-select";
import { useTheme } from "../../Hooks";

export const TimeSelector = ({
                                 isDisabled,
                                 initialValue,
                                 onChange = () => {},
                             }) => {
    const { theme } = useTheme();
    const [value, setValue] = useState({});

    useEffect(() => {
        if (
            initialValue &&
            initialValue > 0 &&
            initialValue != value.TotalMinutos
        ) {
            let remaining = initialValue;
            let _days = remaining >= 1440 ? Math.trunc(remaining / 1440) : 0;
            if (_days > 0) {
                remaining %= 1440;
            }
            let _hours = remaining >= 60 ? Math.trunc(remaining / 60) : 0;
            if (_hours > 0) {
                remaining %= 60;
            }
            let _minutes = remaining;
            setValue((prevValue) => ({
                ...prevValue,
                days: _days,
                hours: _hours,
                minutes: _minutes,
            }));
        }
    }, [initialValue]);

    useEffect(() => {
        if (value && value.TotalMinutos > 0 && initialValue != value.TotalMinutos) {
            onChange(value);
        }
    }, [value.TotalMinutos]);

    useEffect(() => {
        let total = 0;

        if (!isNaN(value.days)) {
            total += value.days * 24 * 60;
        }
        if (!isNaN(value.hours)) {
            total += value.hours * 60;
        }
        if (!isNaN(value.minutes)) {
            total += value.minutes;
        }
        setValue((prevValue) => ({
            ...prevValue,
            TotalMinutos: total,
        }));
    }, [value.minutes, value.hours, value.days]);

    useEffect(() => {
        if (value.days < 0) {
            setValue({ ...value, days: 0 });
        }
    }, [value.days]);

    const getMinutes = () => {
        return [...Array(60).keys()].map((val) => {
            let label;
            if (val < 10) label = `0${val}`;
            else label = `${val}`;
            return {
                value: val,
                label,
            };
        });
    };

    const getHours = () => {
        return [...Array(24).keys()].map((val) => {
            let label;
            if (val < 10) label = `0${val}`;
            else label = `${val}`;
            return {
                value: val,
                label,
            };
        });
    };

    const styleObj = {
        rigthDiv: {
            width: "80px",
            borderRadius: "0px 5px 5px 0px",
            justifyContent: "center",
            border: "2px",
            borderStyle: "solid",
            borderColor: theme.color1,
            backgroundColor: "white",
        },
    };

    return (
        <>
            <Row>
                <Col md={4}>
                    <InputGroup>
                        <Form.Control
                            disabled={isDisabled}
                            type="number"
                            value={value?.days}
                            onChange={(e) => {
                                setValue({ ...value, days: e.target.value });
                            }}
                            onBlur={(e) => setValue({ ...value, days: e.target.value })}
                            style={{ maxWidth: "80px" }}
                        />
                        <InputGroup.Text style={{ fontStyle: "italic" }}>
                            días
                        </InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={4}>
                    <InputGroup>
                        <Select
                            isDisabled={isDisabled}
                            className="basic-single"
                            classNamePrefix="select"
                            name="horas"
                            placeholder="00"
                            menuPosition="fixed"
                            menuPlacement="auto"
                            onChange={(e) => setValue({ ...value, hours: e.value })}
                            options={getHours()}
                            value={getHours().filter(function (option) {
                                return option.value === value?.hours;
                            })}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "80px",
                                }),
                            }}
                        />
                        <InputGroup.Text style={{ fontStyle: "italic" }}>
                            horas
                        </InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={4}>
                    <InputGroup>
                        <Select
                            isDisabled={isDisabled}
                            className="react-select primary"
                            classNamePrefix="react-select-custom"
                            name="minutos"
                            placeholder="00"
                            menuPosition="fixed"
                            menuPlacement="auto"
                            onChange={(e) => setValue({ ...value, minutes: e.value })}
                            options={getMinutes()}
                            value={getMinutes().filter(function (option) {
                                return option.value === value?.minutes;
                            })}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "80px",
                                }),
                            }}
                        />
                        <InputGroup.Text style={{ fontStyle: "italic" }}>
                            minutos
                        </InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>
        </>
    );
};
